<template>
    <div class="overlay" :class="{active: this.$root.menu_active}">
        <div class="container">
            <div class="row">
                <div class="col-12 pr-0 top-level">
                    <nav id="main-nav" v-if="menu">
                        <ul>
                            <li v-for="(item) in menu" :key="item.ID">
                                <a :href="item.url" v-html="item.title"></a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
    export default {
        props: {
            menu: {
                type: Array,
                default() {
                    return []
                }
            },
            menu_is_active: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {

            }
        },
        mounted() {
     
        },
    
        methods: {
         
        },
    }
</script>

<style lang="scss" scoped>
    .pl-0 {
        padding-left: 0!important;
    }
    .pr-0 {
        padding-right: 0!important;
    }
    .overlay {
        position: fixed;
        top: 0px; left: 0px; width: 100%; height: 100%;
        background: $blue;
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        transition: opacity .5s ease, visibility 0s .5s ease;
        display: flex;
        flex-flow: wrap row;
        align-items: center;
        overflow-y: scroll;
        overflow-x: hidden;

        .container {
            max-width: 1200px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .row {
            z-index: 100;
        }

        ul.social-media {
            margin-top: 1rem;
            li {
                a {
                    color: $white!important;
                    
                    &:hover {
                    color: $white!important;
                    }
                }
            }
        }

        .top-level {
            position: relative;
            transition: 0.6s all;
            z-index: 10000;

            &.hide-top-level {
                transform: translateX(-100%);
            }
        }

        &.active {
            opacity: 1;
            visibility: visible;
            transition: opacity .5s ease;
        }

        #main-nav {
            position: relative;
            z-index: 2;

            ul {
                list-style: none;
                padding: 0px;
                margin: 0px;
                transition: opacity .5s ease;

                li a, li p {
                    text-decoration: none!important;
                    &.non-active-menu {
                        opacity: 0.3;
                    }

                    &.active-menu {
                        opacity: 1;
                    }

                    &.none-active {
                        opacity: 1!important;
                    }
                }

                li {
                    margin: 2rem 0;
                    display: flex;

                    a, p {
                        font-family: '2MASS J1808', sans-serif;
                        font-weight: bold;
                        transition: opacity .5s ease;
                        color: $white;
                        font-size: 1.3rem;
                        line-height: 1.2;
                        cursor: pointer;

                        @media screen and (min-width: 769px) {
                            font-size: 3rem;
                        }


                        @media screen and (min-width: 1100px) {
                            font-size: 4rem;
                        }

                        &:hover {
                            opacity: 1;
                            color: white;
                        }

                    }
                }
            }
        }  
    }
</style>